import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel } from '@mui/material';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

function DateRangeFilterSingle({
  label,
  date,
  onChange,
}) {
  return (
    <FormControlLabel
      label={label}
      labelPlacement="top"
      control={(
        <DayPickerInput
          formatDate={formatDate}
          parseDate={parseDate}
          placeholder={`${formatDate(new Date())}`}
          keepFocus={false}
          inputProps={{ style: { width: '150%' }, readOnly: true }}
          value={date ? formatDate(date) : undefined}
          onDayChange={(day) => onChange(day)}
        />
)}
    />
  );
}

DateRangeFilterSingle.propTypes = {
  label: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
};

DateRangeFilterSingle.defaultProps = {
  label: '',
  date: undefined,
  onChange: () => {},
};

export default DateRangeFilterSingle;
